/* unplugin-vue-components disabled */import { render } from "./Video.vue?vue&type=template&id=85e8cbc6&scoped=true&ts=true"
import script from "./Video.vue?vue&type=script&lang=ts"
export * from "./Video.vue?vue&type=script&lang=ts"

import "./Video.vue?vue&type=style&index=0&id=85e8cbc6&scoped=true&lang=css"

import exportComponent from "E:\\Workspaces\\VScode\\vue3+TS\\vue案例\\cloudMusicProject-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85e8cbc6"],['__file',"src/views/video/Video.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "85e8cbc6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('85e8cbc6', __exports__)) {
    console.log('reload')
    api.reload('85e8cbc6', __exports__)
  }
  
  module.hot.accept("./Video.vue?vue&type=template&id=85e8cbc6&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('85e8cbc6', render)
  })

}


export default __exports__